module.exports = __webpack_public_path__ + "img/2131.56fa215b.gif";